/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  TextField,
  Tooltip,
  styled,
  TooltipProps,
  tooltipClasses,
  Link,
  Avatar,
} from "@mui/material";
import Iconify from "../../../../components/iconify";
import { useNavigate } from "react-router-dom";
import { DELETE, GET, POST } from "../../../../config/https";
import { usePersistentState } from "../../../../contexts/global-context";
import APIS from "../../../../config/api";
import TableHeader from "./table-header";
import Label from "../../../../components/label";
import TableToolbar from "./table-toolbar";
import Color from "../../../../theme/color";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { GetLocalStorage } from "../../../../utils/local-storage";
import { Icon } from "@iconify/react";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import FullScreenLoader from "../../../../components/full-screen-loader";
import { marginBottomSize } from "../../../../utils/constant";
import moment from "moment";
import toast from "react-hot-toast";
const colDef = [
  {
    key: "name",
    label: "Name",
    sort: true,
    align: "left",
  },
  {
    key: "ShareLink",
    label: "Share Link",
    sort: true,
    align: "left",
  },
  {
    key: "date",
    label: "Date",
    sort: false,
    align: "left",
  },
  {
    key: "soldOut",
    label: "Sold Out",
    sort: false,
    align: "center",
  },
  {
    key: "status",
    label: "Status",
    sort: false,
    align: "center",
  },
  {
    key: "action",
    label: "Action",
    sort: false,
    align: "center",
  },
];

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const editUrlText = {
  urlRout: "",
};

export default function Events() {
  const [state, dispatch]: any = usePersistentState();
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(null);
  const [newOpens, setNewOpen] = useState(false);
  const [id, setId] = useState();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [isDescending, setIsDescending] = useState(false);
  const [sortProperty, setSortProperty] = useState("startDate");
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [eventList, setEventList] = useState<any>([]);
  const [pagination, setPagination] = useState<any>();
  const [eventUrlPopover, setEventUrlPopover] = useState(null);
  const navigate = useNavigate();
  const IsOpen = Boolean(eventUrlPopover);
  const [, setLoginInfo] = useState<any>(false);
  const [urlText, setUrlText] = useState<any>(editUrlText);
  const [urlId, setUrlId] = useState<any>();
  const [allOrganizer, setAllOrganizer] = useState<any>([]);
  const [skipCount, setSkipCount] = useState(true);
  const [searchOrganizerData, setSearchOrganizerData] = useState({
    value: "",
    label: "",
  });
  let userData = GetLocalStorage("loginData");
  const allOrganizerData = allOrganizer
    ?.filter((x: any) => x?.companyName)
    .map((x: any) => ({
      value: x.id,
      label: x.companyName,
    }));

  const EventOrganizerId = searchOrganizerData.value;

  const getAllUsers = async () => {
    await GET(APIS.GET_ALL_USER + `?PageSize=10000`)
      .then((res: any) => {
        if (res?.isSuccess) {
          setAllOrganizer(res?.result);
        }
      })
      .catch(() => {
        console.log("error");
      });
  };
  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
    getAllUsers();
  }, [state.users]);

  useEffect(() => {
    GetEventList(page, rowsPerPage);
  }, [page, rowsPerPage, searchOrganizerData, isDescending, sortProperty]);

  useEffect(() => {
    if (skipCount) {
      setSkipCount(false);
    } else {
      const delay = setTimeout(() => {
        GetEventList(page, rowsPerPage);
      }, 1100);
      return () => clearTimeout(delay);
    }
  }, [filterName]);

  useEffect(() => {
    let keysToRemove = [
      "eventDetails",
      "eventVenue",
      "eventSchedule",
      "eventTicketConfig",
      "eventFaq",
    ];
    keysToRemove.map((x) => {
      localStorage.removeItem(x);
    });
  }, []);
  const handleClick = (event: any, id: any, eventRouting: string) => {
    let value = { ...urlText };
    value.urlRout = eventRouting;
    setUrlText(value);
    setUrlId(id);
    setEventUrlPopover(event.currentTarget);
  };

  const getOrganizerId = () => {
    if (EventOrganizerId) {
      return EventOrganizerId;
    }
    if (!EventOrganizerId && userData?.roles?.id === 1) {
      return "";
    }
    if (!EventOrganizerId && userData?.roles?.id === 2) {
      return userData?.id;
    }
  };

  const GetEventList = async (PageNumber?: number, rowsPerPage?: number) => {
    setLoader(true);
    const pageNumber: any = (page + 0).toString();
    let organizerId = await getOrganizerId();
    await GET(
      APIS.GET_EVENT_DETIAL_ADMIN +
        "?SearchValue=" +
        filterName +
        "&OrganizerId=" +
        organizerId +
        "&isAll=false" +
        "&PageNumber=" +
        pageNumber +
        "&PageSize=" +
        rowsPerPage +
        "&IsDescending=" +
        isDescending +
        "&SortProperty=" +
        sortProperty
    )
      .then((res: any) => {
        setPagination(res);
        if (res?.isSuccess) {
          dispatch({ EventList: res.result });
          setEventList(res.result);
        } else {
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleClickOpen = () => {
    setNewOpen(true);
  };

  const handleClose = () => {
    setNewOpen(false);
    setOpen(null);
    setEventUrlPopover(null);
  };

  const DeleteEvent = async () => {
    setLoader(true);
    try {
      const res: any = await DELETE(APIS.DELETE_EVENT + "/" + id);
      if (res?.isSuccess) {
        toast.success("Event has been deleted successfully");
        GetEventList(0, 10);
      } else {
        toast.error("Failed to delete event.Please try again later.");
      }
    } catch (error) {
      toast.error("Failed to delete event.Please try again later.");
      console.error("An error occurred while deleting the event:", error);
    } finally {
      setLoader(false);
      handleClose();
      handleCloseMenu();
    }
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleSort = (event: any, property: any) => {
    let mappedProperty = property;
    if (property === "name") {
      mappedProperty = "title";
    } else if (property === "date") {
      mappedProperty = "startDate";
    } else if (property === "status") {
      mappedProperty = "isPublish";
    } else if (property === "soldOut") {
      mappedProperty = "isSoldOut";
    }
    setSortProperty(mappedProperty);
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setIsDescending(order === "asc" ? true : false);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event: any) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  const handleFilterByOrganizer = (event: any, newValue: any) => {
    if (newValue === null) {
      setSearchOrganizerData({ value: "", label: "" });
    } else {
      setSearchOrganizerData(newValue);
    }
  };

  var hostName = window.location.protocol + "//" + window.location.host;

  const isNotFound = (!eventList.length && !!filterName) || !eventList.length;

  const isSoldOutYesNo = (isSoldOut: boolean) => {
    if (isSoldOut) {
      return <Label color={"success"}>{"Yes"} </Label>;
    } else {
      return <Label color={"error"}>{"No"} </Label>;
    }
  };
  const getByIdEventDetail = async () => {
    try {
      if (!id) return;
      await GET(`${APIS.GET_BY_ID_EVENT}?id=${id}`)
        .then((res: any) => {
          if (res?.isSuccess) {
            if (res?.result) {
              localStorage.setItem("eventDetails", JSON.stringify(res?.result));
            }
            if (res?.result?.eventVenues) {
              localStorage.setItem(
                "eventVenue",
                JSON.stringify(res?.result?.eventVenues)
              );

              let newData = [0];
              dispatch({ FilledSteps: newData });
            } else {
              dispatch({ WizardKey: 1 });
              return;
            }
            if (res?.result?.eventSchedules.length !== 0) {
              localStorage.setItem(
                "eventSchedule",
                JSON.stringify(res?.result?.eventSchedules)
              );
              let newData = [0, 1];
              dispatch({ FilledSteps: newData });
            } else {
              dispatch({ WizardKey: 1 });
              return;
            }
            if (res?.result?.eventTicketConfigs.length !== 0) {
              localStorage.setItem(
                "eventTicketConfig",
                JSON.stringify(res?.result?.eventTicketConfigs)
              );
              let newData = [0, 1, 2];
              dispatch({ FilledSteps: newData });
            } else {
              dispatch({ WizardKey: 2 });
              return;
            }
            if (res?.result?.eventFaqs.length !== 0) {
              localStorage.setItem(
                "eventFaq",
                JSON.stringify(res?.result?.eventFaqs)
              );
              let newData = [0, 1, 2, 3];
              dispatch({ FilledSteps: newData });
              dispatch({ WizardKey: 0 });
            } else {
              dispatch({ WizardKey: 3 });
              return;
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch {}
  };

  const handleEditClick = async (id: any) => {
    await getByIdEventDetail();
    navigate(`/dashboard/event/${id}/edit`, {
      state: {
        id: id,
        isEditable: true,
      },
    });
  };

  const onChangeText = (e: any) => {
    let newValue = { ...urlText };
    newValue.urlRout = e.target.value;
    setUrlText(newValue);
  };

  const HandleEventRouting = async () => {
    setLoader(true);
    let param: any = {
      id: urlId,
      eventRouting: urlText?.urlRout,
    };
    await POST(APIS.EVENT_ROUTING, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setEventUrlPopover(null);
          GetEventList(0, 10);
        } else {
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <>
      <Helmet>
        <title> Event | EventPrix </title>
      </Helmet>
      <FullScreenLoader open={loader} />
      <Container maxWidth={"xl"} style={{ marginBottom: marginBottomSize }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Icon
              width="30"
              height="30"
              style={{ marginRight: 5 }}
              icon="carbon:event"
            />
            <Typography variant="h4">Events</Typography>
          </div>
        </Stack>
        <Card>
          <TableToolbar
            placeholder={"Search Event..."}
            onSearch={handleFilterByName}
            options={allOrganizerData}
            value={searchOrganizerData}
            onChange={handleFilterByOrganizer}
          />

          <TableContainer
            sx={{ minWidth: 300, minHeight: 300, overflow: "auto" }}
          >
            <Table>
              <TableHeader
                order={order}
                orderBy={orderBy}
                columnDefinition={colDef}
                rowCount={eventList.length}
                onSort={handleSort}
                sortableColumns={[
                  "name",
                  "date",
                  "status",
                  "eventLink",
                  "soldOut",
                ]}
              />
              <TableBody>
                {eventList?.map((row: any, index: number) => {
                  const {
                    title,
                    id,
                    eventRouting,
                    isSoldOut,
                    startDate,
                    publicSchedule,
                    isPublish,
                  } = row;
                  return (
                    <TableRow hover tabIndex={-1} role="checkbox" key={index}>
                      <TableCell component="th" scope="row" padding="normal">
                        <Stack
                          style={{ paddingLeft: "10px", width: 200 }}
                          direction="row"
                          alignItems="center"
                          spacing={2}
                        >
                          <Typography variant="subtitle2">{title}</Typography>
                        </Stack>
                      </TableCell>

                      <TableCell component="th" scope="row" padding="normal">
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <LightTooltip
                            title={`${hostName}/event/${eventRouting || id}`}
                            placement="top-start"
                          >
                            <Link
                              color={Color.primary}
                              onClick={() =>
                                navigate(`/event/${eventRouting || id}`, {
                                  state: {
                                    eventId: eventRouting || id,
                                  },
                                  // replace: true,
                                })
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                              noWrap
                            >
                              {`${hostName}/event/${eventRouting || id}`.length > 20
                                ? `${hostName}/event/${eventRouting || id}`.substring(
                                    0,
                                    20
                                  ) + "..."
                                : `${hostName}/event/${eventRouting || id}`}
                            </Link>
                          </LightTooltip>
                          <Iconify
                            style={{ color: Color.secondary, height: 17 }}
                            icon={"eva:edit-fill"}
                            // onClick={handleClick}
                            onClick={(e: any) =>
                              handleClick(e, id, eventRouting)
                            }
                          />
                          <Popover
                            id={id}
                            elevation={1}
                            open={IsOpen}
                            anchorEl={eventUrlPopover}
                            onClose={handleClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <div style={{ padding: "20px" }}>
                              <div style={{ display: "flex" }}>
                                <Typography
                                  style={{
                                    display: "flex",
                                    paddingTop: 1,
                                  }}
                                >
                                  {`${hostName}/event/`}
                                </Typography>
                                <TextField
                                  size="small"
                                  placeholder="Share Link"
                                  id="url-heading"
                                  variant="standard"
                                  value={urlText?.urlRout}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  onChange={(event) => onChangeText(event)}
                                />
                                <Button
                                  style={{ marginLeft: 10 }}
                                  variant="contained"
                                  color="primary"
                                  onClick={HandleEventRouting}
                                >
                                  Edit
                                </Button>
                              </div>
                            </div>
                          </Popover>
                        </Stack>
                      </TableCell>

                      <TableCell align="left">
                        {startDate
                          ? moment(startDate).format("MMM DD, YYYY")
                          : ""}
                      </TableCell>

                      <TableCell align="center">
                        {isSoldOutYesNo(isSoldOut)}
                      </TableCell>

                      <TableCell align="center">
                        {isPublish === false && publicSchedule ? (
                          <Label color={"warning"}>{"Schedule Publish"}</Label>
                        ) : isPublish === true ? (
                          <Label color={"success"}>{"Published"}</Label>
                        ) : (
                          <Label color={"info"}>{"Draft"}</Label>
                        )}
                      </TableCell>

                      <TableCell align="center">
                        <IconButton
                          size="large"
                          color="inherit"
                          onClick={(event: any) => {
                            setId(id);
                            setOpen(event.currentTarget);
                          }}
                        >
                          <Iconify icon={"eva:more-vertical-fill"} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: "center",
                          height: "160px",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Typography variant="h5" paragraph>
                          No Data found
                        </Typography>
                        {filterName ? (
                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete
                            words.
                          </Typography>
                        ) : (
                          ""
                        )}
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={pagination?.totalRecords ?? 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{ overflow: "auto" }}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "center", horizontal: "left" }}
        transformOrigin={{ vertical: "center", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 200,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <a
            style={{
              textDecoration: "none",
              color: "black",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            href={`${APIS.DOWNLOAD_CSV}/${id}`}
          >
            <Iconify icon={"bxs:download"} sx={{ mr: 2 }} />
            Download Report
          </a>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleEditClick(id && id);
          }}
        >
          <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: "error.main" }} onClick={handleClickOpen}>
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
        <Dialog
          open={newOpens}
          onClose={handleClose}
          aria-labelledby="delete-dialog-title"
        >
          <DialogContent>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                sx={{ backgroundColor: Color.primary, width: 60, height: 60 }}
              >
                <ReportProblemOutlinedIcon sx={{ height: 30, width: "60%" }} />
              </Avatar>
            </div>
            <Typography sx={{ marginTop: 2 }}>
              {" "}
              Are you sure you want to delete?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button style={{ color: "black" }} onClick={handleClose}>
              Cancel
            </Button>
            <Button
              onClick={DeleteEvent}
              variant="contained"
              sx={{
                backgroundColor: Color.color6,
                "&:hover": { backgroundColor: Color.color6 },
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Popover>
    </>
  );
}
